var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.12,30.19H13.86a.76.76,0,0,1-.65-.37.77.77,0,0,1,0-.75l4.07-7a.73.73,0,0,1,.63-.37.68.68,0,0,1,.64.34l2.32,3.57L24.8,18.1a.73.73,0,0,1,.67-.4.74.74,0,0,1,.66.41l5.65,11a.76.76,0,0,1,0,.73A.74.74,0,0,1,31.12,30.19Zm-16-1.5H29.89l-4.43-8.61-3.85,7.34a.8.8,0,0,1-.63.4.77.77,0,0,1-.67-.34L18,23.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.55,20a2.58,2.58,0,1,1,2.58-2.58A2.58,2.58,0,0,1,19.55,20Zm0-3.66a1.08,1.08,0,1,0,0,2.16,1.08,1.08,0,0,0,0-2.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.064772a364815962a46f1d959a019fe0.svg";
export { ForwardRef as ReactComponent };